import React from 'react';
import {
  Label,
  Input,
  FormGroup,
} from 'reactstrap';
import PropTypes from 'prop-types'
import StatePicker from '../StatePicker/StatePicker'

export function dateValidate(value) { // MM/DD/YYY
  const MM = 0
  const DD = 1
  const YYYY = 2
  const days = [
    31, //Jan
    28, //Feb
    31, //Mar
    30, //Apr
    31, //May
    30, //Jun
    31, //Jul
    31, //Aug
    30, //Sep
    31, //Oct
    30, //Nov
    31, //Dec
  ]
  let parts = value.split('/')

  if (parts.length < 3
  || parts[MM].length !== 2
  || parts[DD].length !== 2
  || parts[YYYY].length !== 4) return false

  const month = Number(parts[MM])
  const day = Number(parts[DD])
  const year = Number(parts[YYYY])

  if (year < 1900 || year > 3000) return false // odds are
  
  if (month < 1 || month > 12) return false

  if (day < 1 || day > days[month-1]) {
    if (month !== 2) return false

    const leap = year / 4
    if (leap !== Math.trunc(leap))  return false
    if (day > 29) return false
  }
  return true
}

export function yearValidate(value) {
  const v = Number(value)
  if (value && (v < 1000 || v > 2100)) {
    return false
  }
  return true
}

const InputCell = props => {

  const form = props.controlled.form
  const setForm = props.controlled.setForm
  const validated = props.controlled.validated
  const name = props.name
  const radio = props.radio
  const checkbox = props.checkbox
  const value = form[name]
  const validator = props.date ? dateValidate : props.year ? yearValidate : props.validator
  const setIsDirty = props.controlled.setIsDirty ? props.controlled.setIsDirty : () => {}

  function handleChange(e) {
    const {name,value} = e.target;
    setForm({...form,[name]:value});
    setIsDirty(true)
  }

  function handleArrayChange(fieldName, e) {
    const {name,checked} = e.target;
    let newValue = value
    if (checked) {
      if (!value.includes(name)) {
        newValue.push(name)
      }
    } else {
      newValue = value.filter((item) => item !== name )
    }

    setForm({...form,[fieldName]:newValue});
    setIsDirty(true)
  }


  let invalid = false
  if (props.validate) {
    invalid = !validated
    if (validator) {
      invalid = invalid && !validator(value)
    }
    else {
      invalid = invalid && !value
    }
  }
  if (radio) {
    return (
      <FormGroup>
        <legend title={props.tip}>{props.label}</legend>
        {
          props.selectValues.map((item, index) => {
            return (
              <FormGroup check key={item}>
                <Label check title={props.tipValues && props.tipValues[index]}>
                <Input type='radio' name={name} value={item} checked={item === value} onChange={handleChange}/>
                {props.fieldLabel[index]}
                </Label>
              </FormGroup>    
            )
          })
        }
      </FormGroup>
    )
  }
  if (checkbox) {
    return (
      <FormGroup>
        <legend title={props.tip}>{props.label}</legend>
        {
          props.selectValues.map((item, index) => {
            const checked = value.includes(item)
            return (
              <FormGroup check key={item}>
                <Label check title={props.tipValues && props.tipValues[index]}>
                <Input
                  type='checkbox'
                  name={item}
                  value={item}
                  checked={checked}
                  onChange={(e) => handleArrayChange(name, e)}/>
                {props.fieldLabel[index]}
                </Label>
              </FormGroup>    
            )
          })
        }
      </FormGroup>
    )
  }

  return (
    <FormGroup>
      {/* <Label>{props.label}</Label> */}
      <legend title={props.tip}>{props.label}</legend>
      {props.state
      ? <StatePicker
        name={name}
        data-testid={name}
        value={value}
        onChange={handleChange}
        invalid={invalid}
      />
      : <Input
        name={name}
        data-testid={name}
        type={props.type ? props.type : 'text'}
        rows={props.rows}
        value={value}
        onChange={handleChange}
        invalid={invalid}
      />
      }
    </FormGroup>
  )
}

InputCell.propTypes = {
  controlled: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  validate: PropTypes.bool,
  validator: PropTypes.func,
  state: PropTypes.bool,
  date: PropTypes.bool,
  radio: PropTypes.bool,
  checkbox: PropTypes.bool,
  selectValues: PropTypes.array,
  type: PropTypes.string,
  label: PropTypes.string
}

export default InputCell